import axios from "axios";

import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  USER_LOADED_SUCCESS,
  USER_LOADED_FAIL,
  AUTHENTICATED_SUCCESS,
  AUTHENTICATED_FAIL,
  REFRESH_SUCCESS,
  REFRESH_FAIL,
  PASSWORD_RESET_FAIL,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_CONFIRM_FAIL,
  PASSWORD_RESET_CONFIRM_SUCCESS,
  NICKNAME_RESET_FAIL,
  NICKNAME_RESET_SUCCESS,
  NICKNAME_RESET_CONFIRM_FAIL,
  NICKNAME_RESET_CONFIRM_SUCCESS,
  SIGNUP_SUCCESS,
  SIGNUP_FAIL,
  ACTIVATION_SUCCESS,
  ACTIVATION_FAIL,
  LOGOUT,
} from "./types";
// import { load_user_data_by_id } from './user_content';

export const load_user = () => async (dispatch) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/accounts_api/users/me/`,
        config,
      );

      dispatch({
        type: USER_LOADED_SUCCESS,
        payload: { ...response.data },
      });
    } catch (err) {
      dispatch({
        type: USER_LOADED_FAIL,
      });
    }
  } else {
    dispatch({
      type: USER_LOADED_FAIL,
    });
  }
};

export const checkAuthenticated = () => async (dispatch) => {
  try {
    const access = localStorage.getItem("access");
    if (!access) {
      dispatch({ type: "AUTHENTICATED_FAIL" });
      return;
    }

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const bodyAccess = JSON.stringify({ token: access });
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/token/verify/`,
      bodyAccess,
      config,
    );

    if (res.data.code !== "token_not_valid") {
      dispatch({ type: "AUTHENTICATED_SUCCESS" });
      return;
    }
  } catch (err) {
    console.error("Verification failed:", err);
  }

  try {
    const refresh = localStorage.getItem("refresh");
    if (!refresh) {
      dispatch({ type: "REFRESH_FAIL" });
      return;
    }

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const bodyRefresh = JSON.stringify({ refresh });
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/token/refresh/`,
      bodyRefresh,
      config,
    );

    dispatch({
      type: "REFRESH_SUCCESS",
      payload: {
        access: res.data.access,
        refresh: refresh,
      },
    });

    dispatch(load_user());
  } catch (err) {
    console.error("Refresh failed:", err);
    dispatch({ type: "REFRESH_FAIL" });
  }
};

export const login = (email, password) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ email, password });

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/auth_api/login/`,
      body,
      config,
    );

    dispatch({
      type: LOGIN_SUCCESS,
      payload: response.data,
    });

    dispatch(load_user());
  } catch (err) {
    dispatch({
      type: LOGIN_FAIL,
    });
    throw err;
  }
};

// export const signup = (email, nickname, password, re_password) => async dispatch => {
// 	const config = {
// 		headers: {
// 			'Content-Type': 'application/json'
// 		}
// 	};

// 	const body = JSON.stringify({
// 		nickname, email, password, re_password
// 	});

// 	try {
// 		const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/`, body, config);

// 		dispatch({
// 			type: SIGNUP_SUCCESS,
// 			payload: res.data
// 		});
// 	} catch (err) {
// 		dispatch({
// 			type: SIGNUP_FAIL
// 		})
// 	}
// };

// export const activate_acc = (uid, token) => async dispatch => {
// 	const config = {
// 		headers: {
// 			'Content-Type': 'application/json',
// 			'Accept': 'application/json'

// 		}
// 	};

// 	const body = JSON.stringify({ uid, token });

// 	try {
// 		await axios.post(`${process.env.REACT_APP_API_URL}/users/activation/`, body, config);

// 		dispatch({
// 			type: ACTIVATION_SUCCESS,
// 		});

// 		dispatch(load_user());
// 	} catch (err) {
// 		dispatch({
// 			type: ACTIVATION_FAIL
// 		})
// 	}
// };

export const verify = (uid, token) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ uid, token });

  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/token/verify/`,
      body,
      config,
    );

    dispatch({
      type: ACTIVATION_SUCCESS,
    });
  } catch (err) {
    dispatch({
      type: ACTIVATION_FAIL,
    });
  }
};

// export const reset_nickname = (email) => async dispatch => {
// 	const config = {
// 		headers: {
// 			'Content-Type': 'application/json'
// 		}
// 	};

// 	const body = JSON.stringify({ email });

// 	try {
// 		await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/reset_nickname/`, body, config);

// 		dispatch({
// 			type: NICKNAME_RESET_SUCCESS
// 		});
// 	} catch (err) {
// 		dispatch({
// 			type: NICKNAME_RESET_FAIL
// 		});
// 	}
// };

// export const reset_nickname_confirm = (uid, token, new_nickname, re_new_nickname) => async dispatch => {
// 	const config = {
// 		headers: {
// 			'Content-Type': 'application/json'
// 		}
// 	};

// 	const body = JSON.stringify({ uid, token, new_nickname, re_new_nickname });

// 	try {
// 		await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/reset_nickname_confirm/`, body, config);

// 		dispatch({
// 			type: NICKNAME_RESET_CONFIRM_SUCCESS
// 		});
// 	} catch (err) {
// 		dispatch({
// 			type: NICKNAME_RESET_CONFIRM_FAIL
// 		});
// 	}
// }

// export const reset_password = (email) => async dispatch => {
// 	const config = {
// 		headers: {
// 			'Accept-Language': 'es',
// 			'Content-Type': 'application/json'
// 		}
// 	};

// 	const body = JSON.stringify({ email });

// 	try {
// 		const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/users/reset_password/`, body, config);

// 		dispatch({
// 			type: PASSWORD_RESET_SUCCESS
// 		});
// 	} catch (err) {
// 		dispatch({
// 			type: PASSWORD_RESET_FAIL
// 		});
// 	}
// };

export const reset_password_confirm =
  (uid, token, new_password1, new_password2) => async (dispatch) => {
    const config = {
      headers: {
        "Accept-Language": "es",
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({ uid, token, new_password1, new_password2 });

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/auth_api/password/reset/confirm/`,
        body,
        config,
      );

      dispatch({
        type: PASSWORD_RESET_CONFIRM_SUCCESS,
      });
      dispatch(logout());

      return Promise.resolve();
    } catch (err) {
      dispatch({
        type: PASSWORD_RESET_CONFIRM_FAIL,
      });
      return Promise.reject(err);
    }
  };

export const logout = () => async (dispatch) => {
  if (localStorage.getItem("access")) {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        Accept: "application/json",
      },
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth_api/logout/`,
        config,
      );

      dispatch({
        type: LOGOUT,
      });
    } catch (err) {
      dispatch({
        type: LOGOUT,
      });
    }
  } else {
    dispatch({
      type: LOGOUT,
    });
  }
};
